import Message from '../components/Message';
import GoogleLoginButton from '../components/GoogleLoginButton';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import './AuthPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) return;

    const checkAuth = async () => {
      try {
        const response = await api.getCurrentUser();
        if (response.data) navigate('/');
      } catch (err) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
      }
    };
    checkAuth();
  }, [navigate]);

  const completeLogin = useCallback((response) => {
    const { access_token, user } = response.data;
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('user', JSON.stringify(user));
    navigate('/');
  }, [navigate]);

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.login(loginForm);
      completeLogin(response);
    } catch (err) {
      setError(err.response?.data?.detail || '登录失败，请检查邮箱和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <section className="auth-showcase">
        <div>
          <span>Jira Automation</span>
          <h1>AI 驱动的工单自动化助手</h1>
          <p>自动理解工单内容，智能匹配处理规则，让重复操作自动完成，让团队专注处理关键问题。</p>
        </div>
        <div className="auth-showcase-strip">
          <strong>Shopline only</strong>
          <small>仅限 Shopline 企业账号</small>
        </div>
      </section>

      <section className="auth-panel">
        <div className="auth-header">
          <span>Sign in</span>
          <h2>登录控制台</h2>
          <p>使用企业 Google 账号或已有账号密码登录。</p>
        </div>

        <Message message={error} type="error" />

        <GoogleLoginButton onSuccess={completeLogin} onError={setError} />

        <form onSubmit={handleLoginSubmit} className="auth-form">
          <label>
            <span>邮箱</span>
            <input
              type="email"
              value={loginForm.email}
              onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
              placeholder="name@shopline.com"
              required
            />
          </label>
          <label>
            <span>密码</span>
            <input
              type="password"
              value={loginForm.password}
              onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
              placeholder="请输入密码"
              required
            />
          </label>
          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? '登录中...' : '登录'}
          </button>
        </form>

        <div className="auth-footer">
          <p>需要账号或权限调整，请联系管理员。</p>
        </div>
      </section>
    </div>
  );
};

export default LoginPage;
